/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { workspaceAPI, walletAPI, facturesAPI } from '../services/api';

// ─── Helpers ─────────────────────────────────────────────────────────────
const fmtEUR = (n) => Number(n || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });
const fmtDate = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }); }
  catch { return '—'; }
};
const fmtMonth = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }); }
  catch { return '—'; }
};

const PLAN_LABELS = { starter: 'Starter', pro: 'Pro', enterprise: 'Enterprise' };
const FACTURE_STATUS = {
  brouillon:   { label: 'Brouillon',  color: '#9B9890' },
  emise:       { label: 'Émise',      color: '#1d4ed8' },
  payee:       { label: 'Payée',      color: '#22c55e' },
  en_retard:   { label: 'En retard',  color: '#b3261e' },
  annulee:     { label: 'Annulée',    color: '#9B9890' },
};

// ─── Composant Field réutilisable (lignes label/value) ───────────────────
function Field({ label, value }) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      padding: '7px 0',
      borderBottom: '0.5px solid rgba(0,0,0,0.05)',
      alignItems: 'center',
    }}>
      <div style={{ fontSize: '12px', color: '#9B9890' }}>{label}</div>
      <div style={{ fontSize: '12px', color: '#1A1916', fontWeight: 500 }}>{value || '—'}</div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// PAGE
// ═══════════════════════════════════════════════════════════════

export default function MonCompte() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('profil');

  const [workspace, setWorkspace] = useState(null);
  const [wallet, setWallet] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [factures, setFactures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [ws, w, tx, fac] = await Promise.allSettled([
          workspaceAPI.get(),
          walletAPI.get(),
          walletAPI.transactions({ limit: 10 }),
          facturesAPI.list(),
        ]);
        if (cancelled) return;
        if (ws.status === 'fulfilled') setWorkspace(ws.value.data || null);
        if (w.status === 'fulfilled') setWallet(w.value.data || null);
        if (tx.status === 'fulfilled') setTransactions(Array.isArray(tx.value.data) ? tx.value.data : []);
        if (fac.status === 'fulfilled') setFactures(Array.isArray(fac.value.data) ? fac.value.data : []);
      } catch {} finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const TABS = [
    { id: 'profil',    label: 'Profil' },
    { id: 'workspace', label: 'Workspace' },
    { id: 'wallet',    label: 'Wallet INPI' },
    { id: 'factures',  label: 'Factures Lexback' },
  ];

  if (loading) return <div style={{ padding: '2rem', color: '#6B6960' }}>Chargement…</div>;

  const plan = workspace?.plan || user?.workspace?.plan || 'starter';
  const planLabel = PLAN_LABELS[plan] || 'Starter';

  return (
    <div>

      {/* Header */}
      <div style={{ marginBottom: '1.5rem' }}>
        <div style={{ fontSize: '20px', fontWeight: 500, color: '#1A1916' }}>Mon compte</div>
        <div style={{ fontSize: '13px', color: '#6B6960', marginTop: '2px' }}>
          Profil, workspace, wallet INPI et factures.
        </div>
      </div>

      {/* Tabs */}
      <div style={{
        display: 'flex',
        gap: '4px',
        marginBottom: '20px',
        borderBottom: '0.5px solid rgba(0,0,0,0.08)',
      }}>
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setActiveTab(t.id)}
            style={{
              padding: '8px 16px',
              fontSize: '13px',
              cursor: 'pointer',
              background: 'transparent',
              border: 'none',
              borderBottom: activeTab === t.id ? '2px solid #B8860B' : '2px solid transparent',
              color: activeTab === t.id ? '#B8860B' : '#6B6960',
              marginBottom: '-1px',
              fontFamily: 'inherit',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* ═══════════════════════ TAB : PROFIL ═══════════════════════ */}
      {activeTab === 'profil' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>

          <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
            <div style={{ fontSize: '13px', fontWeight: 500, color: '#1A1916', marginBottom: '14px' }}>
              Informations personnelles
            </div>
            <Field label="Prénom" value={user?.prenom} />
            <Field label="Nom" value={user?.nom} />
            <Field label="Email" value={user?.email} />
            <Field label="Rôle" value={user?.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : '—'} />
          </div>

          <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
            <div style={{ fontSize: '13px', fontWeight: 500, color: '#1A1916', marginBottom: '14px' }}>
              Sécurité
            </div>
            <Field label="Dernière connexion" value={fmtDate(user?.last_login)} />
            <Field label="2FA" value="Non activé" />
            <div style={{ marginTop: '16px' }}>
              <button style={{
                background: '#B8860B',
                color: '#fff',
                border: 'none',
                padding: '7px 18px',
                borderRadius: '7px',
                fontSize: '12px',
                fontWeight: 500,
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}>
                Changer le mot de passe
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ═══════════════════════ TAB : WORKSPACE ═══════════════════════ */}
      {activeTab === 'workspace' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>

          <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
            <div style={{ fontSize: '13px', fontWeight: 500, color: '#1A1916', marginBottom: '14px' }}>
              Informations workspace
            </div>
            <Field label="Nom" value={workspace?.name} />
            <Field label="SIREN" value={workspace?.siren} />
            <Field label="Statut" value={workspace?.status === 'active' ? 'Actif' : workspace?.status} />
            <Field label="Plan actif" value={planLabel} />
            <Field label="Créé le" value={fmtDate(workspace?.created_at)} />
          </div>

          <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
            <div style={{ fontSize: '13px', fontWeight: 500, color: '#1A1916', marginBottom: '14px' }}>
              Plan & tarification
            </div>
            <Field
              label="Forfait mensuel"
              value={workspace?.forfait_mensuel != null ? fmtEUR(workspace.forfait_mensuel) : 'Sur devis'}
            />
            <Field
              label="Dossiers inclus"
              value={workspace?.dossiers_inclus != null ? workspace.dossiers_inclus.toLocaleString('fr-FR') : '—'}
            />
            <Field
              label="Dossier supplémentaire"
              value={workspace?.prix_dossier_sup != null ? `${fmtEUR(workspace.prix_dossier_sup)} HT` : '—'}
            />
            {plan !== 'enterprise' && (
              <div style={{ marginTop: '16px' }}>
                <button style={{
                  background: '#B8860B',
                  color: '#fff',
                  border: 'none',
                  padding: '7px 18px',
                  borderRadius: '7px',
                  fontSize: '12px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                }}>
                  {plan === 'starter' ? 'Passer à Pro' : 'Passer à Enterprise'} →
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ═══════════════════════ TAB : WALLET INPI ═══════════════════════ */}
      {activeTab === 'wallet' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>

          <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
            <div style={{ fontSize: '13px', fontWeight: 500, color: '#1A1916', marginBottom: '14px' }}>
              Solde wallet
            </div>
            <div style={{
              fontSize: '32px',
              fontWeight: 600,
              color: '#1A1916',
              letterSpacing: '-0.02em',
              marginBottom: '4px',
            }}>
              {fmtEUR(wallet?.balance)}
            </div>
            <div style={{ fontSize: '11px', color: '#9B9890', marginBottom: '14px' }}>
              Seuil d'alerte : {fmtEUR(wallet?.alert_threshold)}
            </div>
            <button style={{
              background: '#B8860B',
              color: '#fff',
              border: 'none',
              padding: '7px 18px',
              borderRadius: '7px',
              fontSize: '12px',
              fontWeight: 500,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}>
              Recharger le wallet
            </button>
          </div>

          <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
            <div style={{ fontSize: '13px', fontWeight: 500, color: '#1A1916', marginBottom: '14px' }}>
              Dernières transactions
            </div>
            {transactions.length === 0 ? (
              <div style={{ fontSize: '12px', color: '#9B9890', padding: '20px 0', textAlign: 'center' }}>
                Aucune transaction.
              </div>
            ) : (
              transactions.slice(0, 6).map(tx => (
                <div key={tx.id} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '7px 0',
                  borderBottom: '0.5px solid rgba(0,0,0,0.05)',
                  fontSize: '12px',
                }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: '#1A1916', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {tx.description || tx.reference || tx.type}
                    </div>
                    <div style={{ fontSize: '10.5px', color: '#9B9890' }}>{fmtDate(tx.created_at)}</div>
                  </div>
                  <div style={{
                    fontWeight: 600,
                    fontSize: '12px',
                    color: Number(tx.montant) >= 0 ? '#22c55e' : '#b3261e',
                    fontFamily: 'monospace',
                    marginLeft: '10px',
                  }}>
                    {Number(tx.montant) >= 0 ? '+' : ''}{fmtEUR(tx.montant)}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {/* ═══════════════════════ TAB : FACTURES ═══════════════════════ */}
      {activeTab === 'factures' && (
        <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
          <div style={{ fontSize: '13px', fontWeight: 500, color: '#1A1916', marginBottom: '14px' }}>
            Historique des factures
          </div>
          {factures.length === 0 ? (
            <div style={{ fontSize: '12px', color: '#9B9890', padding: '30px 0', textAlign: 'center' }}>
              Aucune facture pour le moment.<br />
              <span style={{ fontSize: '11px' }}>
                Vos factures apparaîtront ici dès la fin du premier cycle de facturation.
              </span>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '0.5px solid rgba(0,0,0,0.08)' }}>
                  <th style={{ textAlign: 'left', padding: '8px 0', fontSize: '10.5px', color: '#9B9890', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Référence</th>
                  <th style={{ textAlign: 'left', padding: '8px 0', fontSize: '10.5px', color: '#9B9890', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Période</th>
                  <th style={{ textAlign: 'right', padding: '8px 0', fontSize: '10.5px', color: '#9B9890', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Montant</th>
                  <th style={{ textAlign: 'left', padding: '8px 0', fontSize: '10.5px', color: '#9B9890', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Statut</th>
                </tr>
              </thead>
              <tbody>
                {factures.map(f => {
                  const st = FACTURE_STATUS[f.status] || { label: f.status, color: '#9B9890' };
                  return (
                    <tr key={f.id} style={{ borderBottom: '0.5px solid rgba(0,0,0,0.05)' }}>
                      <td style={{ padding: '10px 0', fontSize: '12px', color: '#1A1916', fontFamily: 'monospace', fontWeight: 500 }}>
                        {f.reference}
                      </td>
                      <td style={{ padding: '10px 0', fontSize: '12px', color: '#6B6960' }}>
                        {fmtMonth(f.periode_mois)}
                      </td>
                      <td style={{ padding: '10px 0', fontSize: '12px', color: '#1A1916', fontWeight: 600, textAlign: 'right', fontFamily: 'monospace' }}>
                        {fmtEUR(f.montant_total)}
                      </td>
                      <td style={{ padding: '10px 0', fontSize: '11px', color: st.color, fontWeight: 500 }}>
                        {st.label}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      )}

    </div>
  );
}
